import { Navigate } from 'react-router-dom';  
import { useContext } from 'react';  
import { AuthContext } from '../contexts/AuthContext';  
  
export function ProtectedRoute({ children }) {  
  const { token } = useContext(AuthContext);  
  
  if (!token) {  
    return <Navigate to="/login" replace />;  
  }  
  
  return children;  
}  
